export default __webpack_public_path__ + "static/logo-d1d2c22228336ccf0d382b542c503be0.svg";